import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from "@angular/material";
import { AngularCsv } from "angular7-csv/dist/Angular-csv";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { first } from "rxjs/operators";
import { PaymentTestingService } from "src/app/services/payment-testing.service";
import { ZoneService } from "src/app/services/zone.service";
import { WebConstants } from "src/app/util/web.constants";
import { PaymentTestingFileUploaderComponent } from "./payment-testing-file-uploader/payment-testing-file-uploader.component";

@Component({
  selector: "app-payments-testing",
  templateUrl: "./payments-testing.component.html",
  //styleUrls: ["./payments-testing.component.scss"],
})
export class PaymentsTestingComponent implements OnInit {
  public form: any;
  public title: string = WebConstants.MENU_NAMES.PAYMENT_TESTING;
  public zoneData: any;
  public selectedServiceZones: any;
  public selectedServiceName: any;
  public data: [] = [];
  public selected: { start; end } = {
    start: moment(),
    end: moment(),
  };
  public dataSource = new MatTableDataSource();
  sampleData: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public ranges: any = {
    Today: [moment().startOf("day"), moment().endOf("day")],
    Tomorrow: [moment().startOf("day"), moment().add(1, "days")],
    Week: [moment().startOf("day"), moment().add(6, "days")],
    Month: [moment().startOf("day"), moment().subtract(29, "days")],
  };

  options = {
    fieldSeparator: ",",
    quoteStrings: "",
    decimalseparator: ".",
    showLabels: true,
    showTitle: false,
    useBom: true,
    headers: [
      "LicensePlate",
      "Payment Service Name",
      "Start Date Time",
      "End Date Time",
      "Zone",
    ],
  };

  public displayedColumns: string[] = [
    "numberPlate",
    "paymentServiceName",
    "startTime",
    "endTime",
    "zone",
  ];

  constructor(
    public zoneService: ZoneService,
    public paymentTestingService: PaymentTestingService,
    public toastrService: ToastrService,
    public dialog: MatDialog
  ) {
    this.getAllZone();
    this.getAllLPNPaymentList();

    this.form = new FormGroup({
      numberPlate: new FormControl("", Validators.required),
      serviceName: new FormControl(""),
      zone: new FormControl("", Validators.required),
    });
  }

  getAllZone(): void {
    this.zoneService
      .getAll()
      .pipe(first())
      .subscribe((response) => {
        console.log(response);
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.zoneData = response.data;
        } else {
          console.log("Zone API Error!");
        }
      });
  }

  onPaymentServesChange(serviceName) {
    this.selectedServiceName = serviceName;
    this.selectedServiceZones = this.zoneData.filter(
      item => item.description === serviceName
    );
  }

  resetForm() {
    this.form.reset();
  }

  fileUploaderDialog(): void {
    const dialogRef = this.dialog.open(PaymentTestingFileUploaderComponent, {
      width: "550px",
      data: null,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.getAllLPNPaymentList();
      }
    });
  }

  addLPNWithPayment() {
    let data = {
      ...this.form.value,
      startTime: +new Date(this.selected.start),
      endTime: +new Date(this.selected.end),
      zoneName: this.getZoneName(this.form.value.zone)
    };
    
    data.numberPlate = data.numberPlate.toUpperCase();
    data.serviceName = (data.serviceName === "Permitted")? "PASSPORT" :data.serviceName.toUpperCase();

    if (data.numberPlate === "") {
      this.toastrService.error("Insert license number!");
    } else {
      this.paymentTestingService
        .addLPNPayment(data)
        .pipe(first())
        .subscribe((response) => {
          if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
            this.toastrService.success(
              response.value,
              "Data Added Successfully!"
            );
            this.getAllLPNPaymentList();
            this.form.reset();
          } else {
            this.toastrService.error(response.value, "Failed To Add Data!");
          }
        });
    }
  }

  getAllLPNPaymentList() {
    this.paymentTestingService
      .getAllLPNPaymentList()
      .pipe(first())
      .subscribe((response) => {
        if (response.code == 9999) {
          window.location.href = "#/access-denied";
        } else if (
          response &&
          response.code === WebConstants.STATUS.CODE_SUCCESS
        ) {
          this.data = response.data;
          this.dataSource = new MatTableDataSource<unknown>(this.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        } else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  excelSheetDownload() {
    let dataForExcel = [];

    this.data.forEach((row: any) => {
      let rowData: any = [
        row.data.numberPlate,
        row.data.paymentServiceName == null ? "" : row.data.paymentServiceName,
        row.data.startTime == null
          ? ""
          : new Date(row.data.startTime).toLocaleString(),
        row.data.endTime == null
          ? ""
          : new Date(row.data.endTime).toLocaleString(),
        row.data.zoneName == null
          ? this.getZoneName(row.data.zoneNumber)
          : row.data.zoneName,
      ];
      dataForExcel.push(rowData);
    });

    let reportData = {
      title: this.title,
      data: dataForExcel,
      headers: ["LicensePlate", "VehicleOwner", "State", "Country", "Zone"],
    };

    new AngularCsv(dataForExcel, this.title, this.options);
  }

  getZoneName(zone) {
    let zoneID = Number(zone);
    let myObj = this.zoneData.filter((x) => x.zoneId == zoneID)[0];
    let myZone = Object.assign({}, myObj);
    return myZone.zoneName;
  }

  sampleCSV() {
    this.sampleData = [
      {
        numberPlate: "kjg1243",
        paymentServiceName: "PARKMOBILE",
        startTime: "2023-08-29 15:50:46.642",
        endTime: "2023-08-29 16:27:26.642	",
        zone: "67th Avenue",
      },
      {
        numberPlate: "tgd1353",
        paymentServiceName: "FLOWBIRD	",
        startTime: "2023-08-29 16:31:21.945	",
        endTime: "2023-08-29 17:48:01.945	",
        zone: "Don Boat Ramp-Maritana Drive",
      },
      {
        numberPlate: "prn1443",
        paymentServiceName: "PASSPORT",
        startTime: "2023-08-29 17:48:01.945	",
        endTime: "2023-08-29 16:31:21.945	",
        zone: "Pass A Grille Way",
      },
    ];

    new AngularCsv(this.sampleData, "SampleCSV", this.options);
  }

  ngOnInit(): void {}
}
